import { Button } from "antd";

export const courseReportColumns = () => [
  {
    title: "Course Name",
    dataIndex: "courseTitle",
    key: "courseTitle",
    width: 250,
  },
  {
    title: "Group Enrollments",
    dataIndex: "groupEnrollments",
    key: "groupEnrollments",
    width: 110,
  },
  {
    title: "User Enrollments",
    dataIndex: "userEnrollments",
    key: "userEnrollments",
    width: 110,
  },
  {
    title: "Unique Enrollments",
    dataIndex: "uniqueEnrollments",
    key: "uniqueEnrollments",
    width: 110,
  },
  {
    title: "Completed",
    dataIndex: "completedEnrollments",
    key: "completedEnrollments",
    width: 110,
  },
  {
    title: "In Progress",
    dataIndex: "inProgressEnrollments",
    key: "inProgressEnrollments",
    width: 120,
  },
  {
    title: "Not Started",
    dataIndex: "notStartedEnrollments",
    key: "notStartedEnrollments",
    width: 100,
  },
  {
    title: "Completed On Time",
    dataIndex: "onTimeCompletedEnrollments",
    key: "onTimeCompletedEnrollments",
    width: 110,
  },
  {
    title: "Completed Late",
    dataIndex: "lateCompletedEnrollments",
    key: "lateCompletedEnrollments",
    width: 110,
  },
  {
    title: "On Track",
    dataIndex: "onTrackEnrollments",
    key: "onTrackEnrollments",
    width: 100,
  },
  {
    title: "Behind Schedule",
    dataIndex: "behindScheduleEnrollments",
    key: "behindScheduleEnrollments",
    width: 100,
  },
  {
    title: "Not Due Yet",
    dataIndex: "notDueYetEnrollments",
    key: "notDueYetEnrollments",
    width: 100,
  },
  {
    title: "No Deadline",
    dataIndex: "noDeadlineEnrollments",
    key: "noDeadlineEnrollments",
    width: 100,
  },
];

export const columnMapping = {
  courseId:                    "Course ID",
  courseTitle:                 "Course Name",
  groupEnrollments:            "Group Enrollments",
  userEnrollments:             "User Enrollments",
  uniqueEnrollments:           "Unique Enrollments",
  completedEnrollments:        "Completed",
  inProgressEnrollments:       "In Progress",
  notStartedEnrollments:       "Not Started",
  onTimeCompletedEnrollments:  "Completed On Time",
  lateCompletedEnrollments:    "Completed Late",
  onTrackEnrollments:          "On Track",
  behindScheduleEnrollments:   "Behind Schedule",
  notDueYetEnrollments:        "Not Due Yet",
  noDeadlineEnrollments:       "No Deadline",
};